module.exports = require("swa-bootstrap-corporate-landing-home-page/password-requirements");